import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { pathConstants } from '../../constants';
import { useAppDispatch } from '../../hooks';
import { userActions } from '../../redux/actions';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle at 20% 20%, #667eea 0%, #764ba2 50%, #f093fb 100%);
`;

const Card = styled.div`
  background: white;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid rgba(102, 126, 234, 0.2);
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 24px;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const Text = styled.p`
  font-size: 16px;
  color: #64748b;
`;

const GoogleCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = searchParams.get('token');
    const refreshToken = searchParams.get('refreshToken');
    const error = searchParams.get('error');

    if (error) {
      console.error('Google login error:', error);
      navigate(pathConstants.LOGIN);
      return;
    }

    if (token) {
      // Parse JWT to get user info (basic decode, no verification needed on client)
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        
        // Store tokens and user info (tokens are already strings, no need to stringify)
        localStorage.setItem('accessToken', token);
        if (refreshToken) {
          localStorage.setItem('refreshToken', refreshToken);
        }
        localStorage.setItem('userInfo', JSON.stringify({
          id: payload.id,
          name: payload.name,
          email: payload.email,
          role: payload.role,
        }));

        // Dispatch success action
        dispatch(userActions.loginSuccess({ token, ...payload }));

        // Check for intended URL
        const intendedUrl = localStorage.getItem('intendedUrl');
        
        if (intendedUrl) {
          localStorage.removeItem('intendedUrl');
          navigate(intendedUrl);
        } else {
          // Redirect based on role
          if (payload.role === 0 || payload.role === 1) {
            navigate(pathConstants.LESSON_DIARY_MANAGE);
          } else if (payload.role === 2) {
            navigate(pathConstants.STUDENT_PAGE);
          } else {
            navigate(pathConstants.ROOT);
          }
        }
      } catch (err) {
        console.error('Failed to parse token:', err);
        navigate(pathConstants.LOGIN);
      }
    } else {
      navigate(pathConstants.LOGIN);
    }
  }, [searchParams, navigate, dispatch]);

  return (
    <Container>
      <Card>
        <Spinner />
        <Text>Đang đăng nhập với Google...</Text>
      </Card>
    </Container>
  );
};

export default GoogleCallback;
